import { jsx, jsxs } from 'react/jsx-runtime';
import { ProtectedRoute } from '../auth/ProtectedRoute.js';
import { SidebarProvider, SidebarInset } from '../ui/sidebar.js';
import { Navigation } from './Navigation.js';

function Layout({ children, sidebar, headerActions }) {
    return (jsx(ProtectedRoute, { children: jsxs(SidebarProvider, { children: [sidebar, jsxs(SidebarInset, { children: [jsx(Navigation, { headerActions: headerActions }), jsx("main", { className: "flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden", children: children })] })] }) }));
}

export { Layout };
//# sourceMappingURL=Layout.js.map
